import type { EventHookOn } from '@vueuse/core';

export interface UseFormNavigationObserver {
  onSubmit: EventHookOn;
  onCancel: EventHookOn;
  onPrevious: EventHookOn;
  triggerSubmit: (id: string) => void;
  triggerCancel: () => void;
  triggerPrevious: () => void;
  lockState: Ref<0 | 1 | 2>;
  lock: (value: 0 | 1 | 2) => void;
  labelSubmit: string;
  submitButtons: Ref<{ id: string; label: string }[]>;
  switchToLocalSubmitButtons: (
    buttons: { id: string; label: string }[]
  ) => void;
  setDefaultSubmitButtons: () => void;
}

export function useFormNavigationObserver(
  labelSubmit = 'Valider'
): UseFormNavigationObserver {
  const submitButtons = ref<{ id: string; label: string }[]>([]);

  const lockState = ref<0 | 1 | 2>(0);
  const submitEvent = createEventHook();
  const triggerSubmit = (id: string) => {
    submitEvent.trigger(id);
  };

  const cancelEvent = createEventHook();
  const triggerCancel = () => {
    cancelEvent.trigger();
  };

  const previousEvent = createEventHook();
  const triggerPrevious = () => {
    previousEvent.trigger();
  };

  const lock = (value: 0 | 1 | 2) => {
    lockState.value = value;
  };

  const switchToLocalSubmitButtons = (
    buttons: { id: string; label: string }[]
  ) => {
    submitButtons.value = buttons;
  };

  const setDefaultSubmitButtons = () => {
    submitButtons.value = [
      {
        id: 'default',
        label: labelSubmit,
      },
    ];
  };

  setDefaultSubmitButtons();

  return {
    onSubmit: submitEvent.on,
    triggerSubmit,
    onCancel: cancelEvent.on,
    triggerCancel,
    onPrevious: previousEvent.on,
    triggerPrevious,
    lockState,
    lock,
    labelSubmit,
    submitButtons,
    switchToLocalSubmitButtons,
    setDefaultSubmitButtons,
  };
}
